import { useEffect, useState, useCallback } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, brl, fmtDateTime, fmtQty, todayISO, MOVE_LABELS } from "@/lib/api";

export function Movements() {
  const [f, setF] = useState({ type: "", start: todayISO(30), end: todayISO() });
  const [list, setList] = useState([]);
  const load = useCallback(() => api.get("/stock/movements", { params: f }).then((r) => setList(r.data)), [f]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        <select value={f.type} onChange={(e) => setF((x) => ({ ...x, type: e.target.value }))} className="h-10 rounded-md border bg-transparent px-2 text-sm" data-testid="movements-type-filter">
          <option value="">Todos os tipos</option>{Object.entries(MOVE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        <Input type="date" value={f.start} onChange={(e) => setF((x) => ({ ...x, start: e.target.value }))} className="w-auto" data-testid="movements-start-input" />
        <Input type="date" value={f.end} onChange={(e) => setF((x) => ({ ...x, end: e.target.value }))} className="w-auto" data-testid="movements-end-input" />
        <Button variant="outline" onClick={load}>Atualizar</Button>
      </div>
      <div className="card-surface overflow-x-auto">
        <Table data-testid="movements-table">
          <TableHeader><TableRow><TableHead>Data</TableHead><TableHead>Item</TableHead><TableHead>Tipo</TableHead><TableHead className="text-right">Qtd.</TableHead><TableHead className="text-right">Saldo</TableHead><TableHead className="text-right">Custo</TableHead><TableHead>Detalhes</TableHead></TableRow></TableHeader>
          <TableBody>
            {list.map((m) => (
              <TableRow key={m.id}>
                <TableCell className="whitespace-nowrap text-xs">{fmtDateTime(m.created_at)}</TableCell>
                <TableCell className="font-medium">{m.item_name}</TableCell>
                <TableCell>{MOVE_LABELS[m.type] || m.type}</TableCell>
                <TableCell className={`text-right font-mono ${m.qty < 0 ? "text-red-500" : "text-emerald-500"}`}>{m.qty > 0 ? "+" : ""}{fmtQty(m.qty)} {m.unit}</TableCell>
                <TableCell className="text-right font-mono text-xs">{fmtQty(m.before)} → {fmtQty(m.after)}</TableCell>
                <TableCell className="text-right font-mono">{brl(m.total_cost)}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{[m.user, m.supplier_name, m.reason, m.ref].filter(Boolean).join(" · ")}</TableCell>
              </TableRow>
            ))}
            {!list.length && <TableRow><TableCell colSpan={7} className="py-8 text-center text-muted-foreground">Nenhuma movimentação no período.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
